import Basic from '@rebuild/materials/shared/layout_floating/LayoutFloating.vue';

export const componentMap = {
	basic: Basic
};
